<template>
  <div class="pointGroupOperation">
    <PointGroupOperationBreadCrumb class="breadCrumb" />
    <div class="wrapper">
      <!--   上半分   -->
      <v-layout class="upperWrapper">
        <OwnerProfileName class="grow" />

        <template v-if="canShowMap && mapLoaded">
          <LocationFilter class="shrink" />
        </template>
      </v-layout>
      <!--   下半分   -->
      <div class="bottomWrapper">
        <div id="area" class="leftMenu">
          <LocationGroupList
            :has-edit-permission="hasEditPermission"
            :geocoder="geocoder"
            :can-add-group="canAddGroup"
            :owner-profile-id="ownerProfileId"
            :hasGroupAddPermission="hasGroupAddPermission"
            @targetGroupType="handleTargetGroupType"
          />
        </div>

        <RightContent
          :has-edit-permission="hasEditPermission"
          :can-show-map="canShowMap"
          :targetGroupType="targetGroupType"
        />
      </div>
      <v-layout class="notice"
        ><small
          >地点入稿数の規定については各個別契約に準拠します。詳しくはヘルプマニュアルをご参照ください。</small
        ></v-layout
      >
    </div>
  </div>
</template>

<script>
import LocationGroupList from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/LocationGroup/LocationGroupList'
import OwnerProfileName from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/PointGroup/OwnerProfileName'
import { actions, getters } from '@/vuex/modules/pointGroupOperation/constants'
import LocationFilter from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/LocationFilter'
import PointGroupOperationBreadCrumb from '@/components/Shared/BreadCrumb/PointGroupOperationBreadCrumb'
import RightContent from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/PointGroupOperationRightContent'
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdvertiser } from '@/mixins/setDrawerTypeAdvertiser'
import { setToolbarTypeAdvertiser } from '@/mixins/setToolBarTypeAdvertiser'
import RouteHelper from '@/mixins/RouteHelper'
import { getGeocoder } from '@/models/Location'

export default {
  name: 'PointGroupOperation',
  components: {
    LocationGroupList,
    PointGroupOperationBreadCrumb,
    OwnerProfileName,
    LocationFilter,
    RightContent,
  },
  mixins: [
    accountInitializer,
    setDrawerTypeAdvertiser,
    setToolbarTypeAdvertiser,
    RouteHelper,
  ],
  data() {
    return {
      geocoder: getGeocoder(),
      targetGroupType: null,
    }
  },
  computed: {
    advertiserId() {
      return this.$route.params.advertiserId
    },
    ownerProfileId() {
      if (isNaN(Number(this.$route.params.ownerProfileId))) {
        console.log(this.advertiserId)
      }
      return Number(this.$route.params.ownerProfileId)
    },
    targetGroup() {
      return this.$store.getters[getters.targetGroup]
    },
    canAddGroup() {
      return !this.underSystemOwnerPage
    },
    canShowMap() {
      return this.$store.getters[getters.groupList].length > 0
    },
    hasUpdates() {
      return this.$store.getters[getters.targetGroupHasUpdates]
    },
    mapLoaded() {
      return this.$store.getters[getters.mapLoaded]
    },
    hasEditPermission() {
      const permission = this.$store.getters[getters.pagePermission]
      return permission === 'admin' || permission === 'edit'
    },
    hasGroupAddPermission() {
      if (this.underAdminPage) return true
      const pagePermission = this.$store.getters[getters.pagePermission]
      return pagePermission === 'edit'
    },
  },
  destroyed() {
    this.$store.dispatch(actions.INIT)
  },
  async beforeRouteLeave(to, from, next) {
    if (this.hasUpdates) {
      const result = await this.$confirm(
        '追加・編集が破棄されますがよろしいですか？',
      )
      if (!result) {
        next(false)
        return
      }
    }
    next()
  },
  methods: {
    handleTargetGroupType(targetGroupType) {
      this.targetGroupType = targetGroupType
    },
  },
}
</script>

<style scoped>
.breadCrumb {
  margin-bottom: 20px;
}
.pointGroupOperation {
  width: 100%;
}
.wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
.upperWrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: -10px;
}
.bottomWrapper {
  display: flex;
  border: 1px solid #999;
  /* 画面高さ - ナビ - padding-top - パンクズ - タイトル - 余白 - padding-bottom */
  height: calc(100vh - 64px - 24px - 41px - 20px - 10px - 24px);
  overflow: hidden;
}
.title {
  flex: 1;
  height: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
}
.filter {
  position: absolute;
  right: 0;
}
.leftMenu {
  flex-basis: 336px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #999;
  position: relative;
}
.notice {
  position: absolute;
  right: 24px;
  bottom: 14px;
}
.buttonGroup {
  max-height: 37px;
}
</style>
